function recordError(errorMessage) {
  fetch('https://log.wojenkins.com/log', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ error: errorMessage })
  })
    .then(response => response.json())
    .then(data => console.log(data))
    .catch(error => console.error('Error:', error));
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      showVatDialog(evt) {
        var vat_declaration_details = sessionStorage.getItem('vat_declaration_details');

        if (vat_declaration_details) {
          var details = JSON.parse(vat_declaration_details);
          this.vatDialog.querySelector('#VATDeclaration-full_name').value = details.full_name;
          this.vatDialog.querySelector('#VATDeclaration-condition').value = details.condition;
          this.vatDialog.querySelector('#VATDeclaration-confirm').checked = details.confirm;
        }
        this.vatDialog.showModal();
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        let submitButton = this.submitButton;

        try {
          // Try block added as we are seeing certain errors for this block
          if (submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          if (submitButton.getAttribute('name') == 'add-vat-relief') {
            this.showVatDialog(evt);
            return;
          }

          // Set the loading state
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
          submitButton.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          // handle the vat exemption
          const declaration_details = JSON.parse(sessionStorage.getItem('vat_declaration_details'));
          const vatDeclarationProperties = {};
          const vatExemptId = this.querySelector('form[data-type="add-to-cart-form"]')?.dataset?.vatExemptId;
          let allowed_vat_exempt = false
          if (declaration_details !== null && vatExemptId !== undefined) {
            if (
              (declaration_details['vatdeclaration[charity_name]'].length && declaration_details['vatdeclaration[charity_number]'].length)
              || (declaration_details['vatdeclaration[condition]'].length && declaration_details['vatdeclaration[full_name]'].length)
            ) {
              allowed_vat_exempt = true;
            }
          }

          if (allowed_vat_exempt) {
            for (const [key, value] of Object.entries(declaration_details)) {
              if (key.startsWith('vatdeclaration') && value !== '') {

                const varPropertyName = key.match(/\[(.*?)\]/)[1];
                formData.append(`properties[_declaration_${varPropertyName}]`, value);
                vatDeclarationProperties[`properties[_declaration_${varPropertyName}]`] = value;
              }
            }
            formData.set('id', vatExemptId);
          }

          // In the event that customers are adding an item with VAT relief,
          // we need to check to see if there are non vat items, and replace
          const cartDrawerItems = document.querySelector('cart-drawer .cart-items');
          if (allowed_vat_exempt &&
            cartDrawerItems && cartDrawerItems?.dataset?.cartMarketHandle === 'gb' && cartDrawerItems?.dataset?.cartHasStandard) {
            const beingAddedVariantId = formData.get('id');
            const itemsToAdd = [{}];

            // Move the currently added item as the first item in the items array,
            // we are the new one, and the ones that need moving over to VAT Relief
            [...formData.entries()].filter(([key, value]) => ['quantity', 'id'].includes(key) || key.startsWith('properties')).forEach(([key, value]) => {
              itemsToAdd[0][key] = value;
            });
            // Find any items in the cart that are not VAT Relief
            // then move them in to the items array to add them to the cart

            const cartItemsWithoutVatRelief = [...cartDrawerItems.querySelectorAll('.cart-item')].filter(item => item.dataset.isStandard).map(item => item.dataset);
            if (cartItemsWithoutVatRelief.length > 0) {
              cartItemsWithoutVatRelief.forEach(item => {
                itemsToAdd.push({
                  id: item.vatExemptId,
                  quantity: (item.vatExemptId === beingAddedVariantId) ? 0 : item.quantity,
                  ...vatDeclarationProperties
                });
              });
            }

            // Build the form data for each of the items
            if (itemsToAdd.length > 1) {

              itemsToAdd.forEach((item, index) => {
                Object.entries(item).forEach(([key, value]) => {
                  formData.set(`items[${index}][${key}]`, value);
                });
              });
              formData.delete('id');
              formData.delete('quantity');

              let updates = {};
              cartItemsWithoutVatRelief.forEach(item => {
                updates[item.standardId] = 0;
              });
              await fetch(`${routes.cart_update_url}`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ updates })
              });
            }
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
                recordError("reqError: " + response.status + ' ' + (response.errors || response.description));

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;

                submitButton.setAttribute('aria-disabled', true);
                submitButton.querySelector('span').classList.add('hidden');

                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;

              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              recordError("fetch: " + e.message);
              if (config.body) {
                recordError(JSON.stringify(config.body));
              }
            })
            .finally(() => {
              submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) submitButton.removeAttribute('aria-disabled');
              submitButton.querySelector('.loading__spinner').classList.add('hidden');
            });

        } catch (e) {
          this.handleErrorMessage("Apologies, an unknown error has occurred. To place your order, please visit the contact us form at the bottom of the page. " + e.message);
          recordError("general: " + e.message);
          if (config.body) {
            recordError(JSON.stringify(config.body));
          }
          return;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
